import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import tags from './modules/tags'
import logs from './modules/logs'
import monitoringWork from './modules/monitoringWork'
import curveAnalysis from './modules/curveAnalysis'
import eCoinMall from './modules/eCoinMall'
import goodSpecStores from "./modules/goodSpecStores";
import adsenseStore from './modules/adsenseStore'
import siteStore from './modules/siteStore'
import revenueDaily from "./modules/revenueDaily";
import shopGoodsManageV3 from "./modules/shopGoodsManageV3";
import goodsDispatch from "./modules/goodsDispatch";
import shopIndent from "./modules/shopIndent";
import workOrderStore from "./modules/workOrderStore";

import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    common,
    logs,
    tags,
    monitoringWork,// 机器监控
    curveAnalysis,// 曲线分析
    eCoinMall, // 鳄币商城
    goodSpecStores, // 套餐规格
    adsenseStore,
    siteStore,
    revenueDaily,
    shopGoodsManageV3, // 三代机门店商品管理
    goodsDispatch, // 商品档案下发
    shopIndent, // 门店订货单
    workOrderStore, // 工单详情
  },
  getters,
  plugins: [
    // veux持久化配置
    createPersistedState({
      paths: ['common', 'logs', 'monitoringWork','curveAnalysis','eCoinMall','goodSpecStores','adsenseStore','revenueDaily','shopGoodsManageV3','goodsDispatch']
    })
  ]
})

export default store
